import { z } from 'zod'
import { useParsedStorage } from '../../../../core'

const ANNOUNCEMENTS_MENU_HINT_DISMISSED_AT_KEY =
  'joyful-announcements-menu-hint-dismissed-at'
const DismissedAtSchema = z.iso.datetime().nullable()

export function useAnnouncementsMenuHint() {
  const [dismissedAt, setDismissedAt] = useParsedStorage(
    ANNOUNCEMENTS_MENU_HINT_DISMISSED_AT_KEY,
    {
      initialValue: null,
      schema: DismissedAtSchema,
      strategy: 'local',
    },
  )

  const dismiss = () => {
    setDismissedAt(new Date().toISOString())
  }

  return {
    dismiss,
    dismissedAt,
  }
}
